export default __webpack_public_path__ + "static/media/jpospmain.6bf6c110.png";